import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetGrowerBenchmarkRetailMonthValuesMutationVariables = Types.Exact<{
  input: Types.SetGrowerBenchmarkRetailMonthValuesInput;
}>;


export type SetGrowerBenchmarkRetailMonthValuesMutation = { __typename?: 'Mutation', setGrowerBenchmarkRetailMonthValues: { __typename?: 'GrowerBenchmarkRetailMonthPayload', month?: { __typename?: 'GrowerBenchmarkRetailMonth', communityId: string, reportingUnitId: string, periodId: string, status?: Types.GrowerBenchmarkSubmissionStatus | null, version?: number | null, submissionId?: string | null, values?: { __typename?: 'GrowerBenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null } | null } | null, warnings: Array<{ __typename?: 'GrowerBenchmarkRetailMonthFinding', field: string, code: string, message: string }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordKind: Types.RecordKind, recordId?: string | null }> | null } };


export const SetGrowerBenchmarkRetailMonthValuesDocument = new TypedDocumentString(`
    mutation SetGrowerBenchmarkRetailMonthValues($input: SetGrowerBenchmarkRetailMonthValuesInput!) {
  setGrowerBenchmarkRetailMonthValues(input: $input) {
    month {
      ...GrowerBenchmarkRetailMonthFields
    }
    warnings {
      field
      code
      message
    }
    errors {
      code
      message
      recordKind
      recordId
    }
  }
}
    fragment GrowerBenchmarkRetailMonthFields on GrowerBenchmarkRetailMonth {
  communityId
  reportingUnitId
  periodId
  status
  version
  submissionId
  values {
    ...GrowerBenchmarkRetailMonthValuesFields
  }
}
fragment GrowerBenchmarkRetailMonthValuesFields on GrowerBenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetGrowerBenchmarkRetailMonthValues: build.mutation<SetGrowerBenchmarkRetailMonthValuesMutation, SetGrowerBenchmarkRetailMonthValuesMutationVariables>({
      query: (variables) => ({ document: SetGrowerBenchmarkRetailMonthValuesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetGrowerBenchmarkRetailMonthValuesMutation } = injectedRtkApi;
